import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useCart } from '../context/CartContext';
import { useI18n } from '../context/I18nContext';

const CartItem = ({ item }) => {
  const { updateQuantity, removeFromCart } = useCart();
  const { t, translateCategory } = useI18n();
  const [imgError, setImgError] = useState(false);

  return (
    <div className="flex items-center gap-4 bg-white p-4 rounded-xl shadow-sm border border-amber-100">
      <Link to={`/products/${item.id}`} className="flex-shrink-0">
        <div className="w-20 h-20 bg-amber-50 rounded-lg overflow-hidden">
          {!imgError ? (
            <img
              src={item.images[0]}
              alt={item.name}
              className="w-full h-full object-cover"
              onError={() => setImgError(true)}
            />
          ) : (
            <div className="w-full h-full flex items-center justify-center">
              <span className="text-3xl">🐾</span>
            </div>
          )}
        </div>
      </Link>
      <div className="flex-1 min-w-0">
        <Link to={`/products/${item.id}`}>
          <h3 className="font-semibold text-gray-800 hover:text-amber-800 transition-colors truncate">
            {item.name}
          </h3>
        </Link>
        <p className="text-sm text-gray-500 mb-2">{translateCategory(item.category)}</p>
        <p className="text-amber-800 font-bold">${item.price.toFixed(2)}</p>
      </div>
      <div className="flex items-center gap-2">
        <button
          onClick={() => updateQuantity(item.id, item.quantity - 1)}
          className="w-8 h-8 rounded-full bg-amber-100 hover:bg-amber-200 text-amber-800 flex items-center justify-center font-bold transition-colors"
        >
          −
        </button>
        <span className="w-8 text-center font-semibold text-gray-800">{item.quantity}</span>
        <button
          onClick={() => updateQuantity(item.id, item.quantity + 1)}
          className="w-8 h-8 rounded-full bg-amber-100 hover:bg-amber-200 text-amber-800 flex items-center justify-center font-bold transition-colors"
        >
          +
        </button>
      </div>
      <div className="text-right">
        <p className="font-bold text-gray-800">${(item.price * item.quantity).toFixed(2)}</p>
        <button
          onClick={() => removeFromCart(item.id)}
          className="text-xs text-red-500 hover:text-red-700 transition-colors mt-1"
        >
          {t('cart.remove')}
        </button>
      </div>
    </div>
  );
};

export default CartItem;
